// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"188e7fa2","395":"31f94e51","485":"e590181b","560":"9516d3fa","897":"e4d249da"}[chunkId] + ".chunk.css";
};